import { useContext, useEffect } from 'react';
import { useLoaderData } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import DebugBarControl from '../../../../library/SimpleControls/DebugBarControl';
import Layout from './Layout';
import { addUserSpecificDomains } from '../../../../library/Service/domainService';


const InternalAdminQRReport = () => {
    
    const { globalState } = useContext(GlobalContext);

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {},
    } as any);

    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;
    let domain = addUserSpecificDomains(new Map([...globalState.domain]), data);
    const allProgramCode = domain.get("ALL_PROGRAM_CODE")?.map((item: any) => ({...item, code: item.value})) || [];
    domain.set("ALL_PROGRAM_CODE", allProgramCode);

    useEffect(() => {
        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig, data, domain, internal, routeInfo },
        });
    }, []);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <DebugBarControl />
            {!state.flags.isDataLoading && <Layout />}
        </SmartContext.Provider>
    );
};

export default InternalAdminQRReport;
